import { useState } from "react"
import { Helmet } from "react-helmet-async"
import { Outlet } from "react-router"
import {
	IntegrationItem,
	type TOAuthClientCredentials,
} from "./../../../../../Integrations"
import { useLocation, useParams } from "../../../../../router-utils"

/**
 * The create flow hands the one-time client credentials over through
 * navigation state; they are shown once on the page and never fetched.
 */
type TCreatedCredentialsState =
	| { oauth_client: TOAuthClientCredentials }
	| null
	| undefined

export default function OAuthIntegrationItemDetailsPage() {
	const location = useLocation()
	const { integrationId } = useParams("/integrations/:integrationId/oauth")
	const state = location.state as TCreatedCredentialsState
	const [createdOAuthClient] = useState<TOAuthClientCredentials | undefined>(
		state && typeof state === "object" ? state.oauth_client : undefined
	)
	const [lastCreatedToken, setLastCreatedToken] = useState<string | undefined>()
	return (
		<>
			<Helmet>
				<title>OAuth App | Integration</title>
			</Helmet>
			<IntegrationItem
				lastCreatedToken={lastCreatedToken}
				createdOAuthClient={createdOAuthClient}
				integrationId={integrationId}
				setLastCreatedToken={setLastCreatedToken}
			>
				{({ integration }) => <Outlet context={{ integration }} />}
			</IntegrationItem>
		</>
	)
}
